<template>
  <div>

    <p>
      I den här lektionen får du lära dig om virala nyheter. Vad innebär det att en nyhet är viral och hur kan någonting få så enorm spridning på internet?
    </p>

  </div>
</template>

<script>

//Exercises

export default {
  components: {
  },
  data () {
    return {
      'name': 'Virala nyheter',
      'route': 'viralanyheter',
      'excercises': {
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/learn/lessons/data/Viral.vue